import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);

// FIXED: Removed React.StrictMode to prevent double-mounting in development
// and reduce unnecessary re-renders. StrictMode was causing duplicate transitions.
root.render(<App />);

serviceWorker.register();
